var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44554 19.6192C8.44458 19.8189 8.61841 19.9375 8.84116 19.9366C8.99761 19.9359 9.16284 19.8734 9.27182 19.7653L16.1137 11.7995C16.6358 11.1981 16.2143 10.2268 15.413 10.2268H12.4627L15.8336 4.83252H11.3119L7.33669 11.7282C6.85718 12.5801 7.47976 13.6538 8.46541 13.6538H11.0246L8.48465 19.46C8.4579 19.5181 8.44579 19.5713 8.44554 19.6192Z",
    fill: "#47A7FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.1c1063b3367e91a3561dd1a9fb91938a.svg";
export { ForwardRef as ReactComponent };